import { useMutation } from "@tanstack/react-query";
import { isAuth } from "../../../api/requests/isAuth";
import { useAuthStore } from "../../store/authStore";

export const useIsAuth = () => {
  const query = useMutation({
    mutationFn: isAuth,
    onSuccess: (response) => {
      useAuthStore.getState().setIsAuthenticated(response.data);
    },
    onError: () => {
      useAuthStore.getState().setIsAuthenticated("false");
    },
  });
  return query;
};
